import { customizeCraftJsComponent } from '../../helpers';
import { EditorButton } from '../EditorButton';
import { EditorProviderButtonSettings } from '../EditorProviderButtonSettings';

export const EditorAppleButton = customizeCraftJsComponent(EditorButton, {
	name: 'Apple Button',
	props: {
		children: '',
		startIcon: 'apple',
		shape: 'square',
		variant: 'outline',
		'data-descope-provider': 'apple',
		startIconColorText: false,
		formNoValidate: true,
		'data-type': 'social'
	},
	related: {
		settings: EditorProviderButtonSettings
	},
	custom: {
		subType: 'social'
	}
});
